<template>
 <div class="energyOverview app-bg">
   <div id="base" class="">


      <!-- Unnamed (Rectangle) -->
      <div id="u3217" class="ax_default box_1">
        <div id="u3217_div" class=""></div>
        <div id="u3217_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3218" class="ax_default box_1">
        <div id="u3218_div" class=""></div>
        <div id="u3218_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3219" class="ax_default button" @click="setFlag1(1)">
        <div id="u3219_div" class=""></div>
        <div id="u3219_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3220" class="ax_default button" @click="setFlag1(2)">
        <div id="u3220_div" class=""></div>
        <div id="u3220_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3221" class="ax_default line">
        <img id="u3221_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3221_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3222" class="ax_default button" @click="setFlag1(3)">
        <div id="u3222_div" class=""></div>
        <div id="u3222_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>

  

      <!-- Unnamed (Group) -->
      <div id="u3224" class="ax_default" data-left="259" data-top="746" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u3225" class="ax_default label">
          <div id="u3225_div" class=""></div>
          <div id="u3225_text" class="text ">
            <p><span>节能目标详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3226" class="ax_default box_1">
          <div id="u3226_div" class=""></div>
          <div id="u3226_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3227" class="ax_default label">
          <div id="u3227_div" class=""></div>
          <div id="u3227_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3228" class="ax_default droplist">
          <div id="u3228_div" class=""></div>
          <select id="u3228_input" class="u3228_input" v-model="queryParams.energyType">
            <option class="u3228_input_option" selected value="">请选择</option>
            <option class="u3228_input_option" value="1">用电</option>
            <option class="u3228_input_option" value="2">用水</option>
            <option class="u3228_input_option" value="3">用气</option>
            <option class="u3228_input_option" value="4">用热</option>
            <option class="u3228_input_option" value="5">其他能源</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3229" class="ax_default label">
          <div id="u3229_div" class=""></div>
          <div id="u3229_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3230" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          <div id="u3230_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3231" class="ax_default primary_button" @click="handleQuery"> 
          <div id="u3231_div" class=""></div>
          <div id="u3231_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3232" class="ax_default box_1">
           <div class="innerbox"  style="width: 100%; height:350px;position: absolute;
z-index: 99;">
                <el-table  :data="consumptionlist"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="能耗类型" align="center" prop="energyType" />
                <el-table-column label="目标节能" align="center" prop="goal" />
                <el-table-column label="实际节能" align="center" prop="savingrate" />
                 <el-table-column label="目标完成度" align="center" prop="completion" />
               
             </el-table>
            
                <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

       

        <!-- Unnamed (Line) -->
        <div id="u3234" class="ax_default _水平线">
          <img id="u3234_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u3234_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

       

        <!-- Unnamed (Rectangle) -->
        <div id="u3236" class="ax_default primary_button">
          <div id="u3236_div" class=""></div>
          <div id="u3236_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3237" class="ax_default label">
          <div id="u3237_div" class=""></div>
          <div id="u3237_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

    
     

      
      </div>
      <div id="u32741" class="ax_default" >
            <el-radio-group v-model="radio" @change="getChange">
            <el-radio :label="0">总目标</el-radio>
            <el-radio :label="1">用电</el-radio>
            <el-radio :label="2">用水</el-radio>
            <el-radio :label="3">用气</el-radio>
            <el-radio :label="4">用热</el-radio>
            <el-radio :label="5">其他能源</el-radio>
          </el-radio-group>
     </div>
  

      <!-- Unnamed (Rectangle) -->
      <div id="u3250" class="ax_default box_1">
        <div id="u3250_div" class=""></div>
        <div id="u3250_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3251" class="ax_default box_1">
        <div id="u3251_div" class=""></div>
        <div id="u3251_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3252" class="ax_default line">
        <img id="u3252_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u338.svg"/>
        <div id="u3252_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3253" class="ax_default label">
        <div id="u3253_div" class=""></div>
        <div id="u3253_text" class="text ">
          <p><span>季度节能&amp;完成度评价&amp;预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3254" class="ax_default box_1">
        <div id="u3254_div" class=""></div>
        <div id="u3254_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3255" class="ax_default heading_1">
        <div id="u3255_div" class=""></div>
        <div id="u3255_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3256" class="ax_default heading_1">
        <div id="u3256_div" class=""></div>
        <div id="u3256_text" class="text ">
          <p><span>——</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3257" class="ax_default heading_1">
        <div id="u3257_div" class=""></div>
        <div id="u3257_text" class="text ">
          <p><span>——</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3258" class="ax_default heading_1">
        <div id="u3258_div" class=""></div>
        <div id="u3258_text" class="text ">
          <p><span>——</span></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3259" class="ax_default" data-left="999" data-top="444" data-width="381" data-height="199">

        <!-- Unnamed (Rectangle) -->
        <div id="u3260" class="ax_default box_1">
          <div id="u3260_div" class=""></div>
          <div id="u3260_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3261" class="ax_default" data-left="999" data-top="501" data-width="379" data-height="129">

          <!-- Unnamed (Group) -->
          <div id="u3262" class="ax_default" data-left="1001" data-top="501" data-width="377" data-height="129">

            <!-- Unnamed (Rectangle) -->
            <div id="u3263" class="ax_default box_1">
              <div id="u3263_div" class=""></div>
              <div id="u3263_text" class="text " style="display:none; visibility: hidden">
                <p></p>
              </div>
            </div>

            <!-- Unnamed (Line) -->
         

            <!-- Unnamed (Line) -->
            <div id="u3265" class="ax_default _水平线">
              <img id="u3265_img" class="img " src="../../../../../../assets/common/performanc/icon/season/u3264.svg"/>
              <div id="u3265_text" class="text " style="display:none; visibility: hidden">
                <p></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3266" class="ax_default heading_1">
              <div id="u3266_div" class=""></div>
              <div id="u3266_text" class="text ">
                <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
              </div>
            </div>
       
         <div id="u32671" class="ax_default heading_1">
               <el-table :data="this.performancForecast" 
          style="border-width:0px"
           :row-style="{height:'3px'}"    
             :cell-style="{textAlign:'center',padding:'1px 0'}" 
            height="80%"
          
           :show-header="false" 
            >
              <el-table-column  prop="time" label=""></el-table-column>
              <el-table-column  prop="forecast" label=""></el-table-column>
       
            </el-table>
            </div>

      
            <!-- Unnamed (Rectangle) -->
            <div id="u3271" class="ax_default heading_1">
              <div id="u3271_div" class=""></div>
              <div id="u3271_text" class="text ">
                <p><span>节能目标（%）</span></p>
              </div>
            </div>
          </div>

          <!-- Unnamed (Line)
          <div id="u3272" class="ax_default _水平线">
            <img id="u3272_img" class="img " src="../../../../../../assets/common/performanc/icon/season/u3264.svg"/>
            <div id="u3272_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>
           -->
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3273" class="ax_default label">
          <div id="u3273_div" class=""></div>
          <div id="u3273_text" class="text ">
            <p><span>季度节能目标预测</span></p>
          </div>
        </div>
      </div>



      <!-- Unnamed (Rectangle) -->
      <div id="u3275" class="ax_default label">
        <div id="u3275_div" class=""></div>
        <div id="u3275_text" class="text ">
          <p><span style="font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;">分区</span><span style="font-family:'ArialMT', 'Arial', sans-serif;">&amp;</span><span style="font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;">分项节能详情</span></p>
        </div>
      </div>



      <!-- Unnamed (Image) -->
      <div id="u3299" class="ax_default image">
               <v-chart
          ref="barChart"
          style="width: 100%;height:330px"
          :options="seasonProportionOptionsRate"
          theme="macarons"
          :auto-resize="true"
        ></v-chart>
        <div id="u3299_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3300" class="ax_default" data-left="999" data-top="253" data-width="381" data-height="181">

        <!-- Unnamed (Group) -->
        <div id="u3301" class="ax_default" data-left="999" data-top="253" data-width="381" data-height="181">

          <!-- Unnamed (Rectangle) -->
          <div id="u3302" class="ax_default box_1">
            <div id="u3302_div" class=""></div>
            <div id="u3302_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

       
          <!-- Unnamed (Rectangle) -->
          <div id="u3305" class="ax_default label">
            <div id="u3305_div" class=""></div>
            <div id="u3305_text" class="text ">
              <p><span>完成度评价</span></p>
            </div>
          </div>

            <div id="u33031" class="ax_default">
           
            <table>        
              <tr width="300" v-for='item in tableData' :key='item.date'>
                <td  width="100">{{item.date}}</td>
                <td  width="100">{{item.name}}</td>
                 <td  width="100" v-if="item.name==='优秀'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3153.png" class="img" width="31" height="29">
                  </td>
                  <td  width="100" v-if="item.name==='良好'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3154.png" class="img" width="31" height="29">
                  </td>
                   <td  width="100" v-if="item.name==='加油'">
                  <img  src="../../../../../../assets/common/performanc/icon/month/u3152.png" class="img" width="31" height="29">
                  </td>
                </tr>
            
                </table>
                
            </div>
        
        </div>
      </div>
    </div>
 </div>

</template>
<script>
import "echarts/theme/macarons";
import {
  getPerformancLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getGasLevel2,//气
  listGas,//气
  getHotLevel2,//热
  listHot,//热
  getOthersLevel2,//其他
  listOthers,//其他
} from "@/api/business/energy/performanc";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
   components: {Pagination},
  data() {
    return {
         flag:1,
           radio: 0,
       list: null,
       curseasonflag: 1,
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      performancForecast: '',
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   energyType: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      monthAnalysis:[],
      yearlyAnalysis:[],
      seasonAnalysis:[],
      energyTypeList: [
        { itemCode: 1, itemName: "电力" },
        { itemCode: 2, itemName: "水" },
        { itemCode: 3, itemName: "天然气" },
        { itemCode: 4, itemName: "热力" },
        { itemCode: 5, itemName: "其他能源" },
      ],

      electricityProportionOptions: null,
      monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      monthlyProportionOptionsRate3: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
      seasonProportionOptionsRate3: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
      yearlyProportionOptionsRate3: null,
      typeflag: 0,
      montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       besturl: "../../../../../../assets/common/performanc/icon/month/u3153.png",
       betterurl: "../../../../../../assets/common/performanc/icon/month/u3154.png",
       goodurl: "../../../../../../assets/common/performanc/icon/month/u3152.png",

      performancLevel1VO: {
        //----------汇总年数据-------------
    //今年总节能目标
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0

    //---今年总节能完成度评价
    powerCompletionYear: "",
    waterCompletionYear: "",
    gasCompletionYear: "",
    hotCompletionYear: "",
    othersCompletionYear: "",
    totalCompletionYear: "",

    //---今年实际完成率
    powerSavingRateYear: "",
    waterSavingRateYear: "",
    gasSavingRateYear: "",
    hotSavingRateYear: "",
    otherschangeRateYear: "",
    totalSavingRateYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------汇总季-----------------------------
    //电
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度节能完成度评价
    totalCompletionSeason1: "",
    totalCompletionSeason2: "",
    totalCompletionSeason3: "",
    totalCompletionSeason4: "",

    //---季用完成率
    totalSavingRateSeason1: "",
    totalSavingRateSeason2: "",
    totalSavingRateSeason3: "",
    totalSavingRateSeason4: "",

    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度节能完成度评价
    powerCompletionSeason1: "",
    powerCompletionSeason2: "",
    powerCompletionSeason3: "",
    powerCompletionSeason4: "",

    //---季用节能率
    powerSavingRateSeason1: "",
    powerSavingRateSeason2: "",
    powerSavingRateSeason3: "",
    powerSavingRateSeason4: "",

    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季度节能完成度评价
    waterCompletionSeason1: "",
    waterCompletionSeason2: "",
    waterCompletionSeason3: "",
    waterCompletionSeason4: "",

    //---季节能完成率
    waterSavingRateSeason1: "",
    waterSavingRateSeason2: "",
    waterSavingRateSeason3: "",
    waterSavingRateSeason4: "",

    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季度节能完成度评价
    gasCompletionSeason1: "",
    gasCompletionSeason2: "",
    gasCompletionSeason3: "",
    gasCompletionSeason4: "",
    //---季节能完成率
    gasSavingRateSeason1: "",
    gasSavingRateSeason2: "",
    gasSavingRateSeason3: "",
    gasSavingRateSeason4: "",

    //--气下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季度节能完成度评价
    hotCompletionSeason1: "",
    hotCompletionSeason2: "",
    hotCompletionSeason3: "",
    hotCompletionSeason4: "",
    //---季节能完成率
    hotSavingRateSeason1: "",
    hotSavingRateSeason2: "",
    hotSavingRateSeason3: "",
    hotSavingRateSeason4: "",

    //--热季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------其他-----------------------------
    //其他
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季度节能完成度评价
    othersCompletionSeason1: "",
    othersCompletionSeason2: "",
    othersCompletionSeason3: "",
    othersCompletionSeason4: "",

    //---季节能完成率
    othersSavingRateSeason1: "",
    othersSavingRateSeason2: "",
    othersSavingRateSeason3: "",
    othersSavingRateSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
    //---------------总节能月----
    //总节能
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总节能完成度评价
    totalCompletionMonth1: "",
    totalCompletionMonth2: "",
    totalCompletionMonth3: "",
    totalCompletionMonth4: "",
    totalCompletionMonth5: "",
    totalCompletionMonth6: "",
    totalCompletionMonth7: "",
    totalCompletionMonth8: "",
    totalCompletionMonth9: "",
    totalCompletionMonth10: "",
    totalCompletionMonth11: "",
    totalCompletionMonth12: "",
    //---总节能完成率
    totalSavingRateMonth1: "",
    totalSavingRateMonth2: "",
    totalSavingRateMonth3: "",
    totalSavingRateMonth4: "",
    totalSavingRateMonth5: "",
    totalSavingRateMonth6: "",
    totalSavingRateMonth7: "",
    totalSavingRateMonth8: "",
    totalSavingRateMonth9: "",
    totalSavingRateMonth10: "",
    totalSavingRateMonth11: "",
    totalSavingRateMonth12: "",


    //--总下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------电月----------------------------
    //电
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电节能完成度评价
    powerCompletionMonth1: "",
    powerCompletionMonth2: "",
    powerCompletionMonth3: "",
    powerCompletionMonth4: "",
    powerCompletionMonth5: "",
    powerCompletionMonth6: "",
    powerCompletionMonth7: "",
    powerCompletionMonth8: "",
    powerCompletionMonth9: "",
    powerCompletionMonth10: "",
    powerCompletionMonth11: "",
    powerCompletionMonth12: "",
    //---月节能完成率
    powerSavingRateMonth1: "",
    powerSavingRateMonth2: "",
    powerSavingRateMonth3: "",
    powerSavingRateMonth4: "",
    powerSavingRateMonth5: "",
    powerSavingRateMonth6: "",
    powerSavingRateMonth7: "",
    powerSavingRateMonth8: "",
    powerSavingRateMonth9: "",
    powerSavingRateMonth10: "",
    powerSavingRateMonth11: "",
    powerSavingRateMonth12: "",


    //--月下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //--------------------------水----------------------------
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水节能完成度评价
    waterCompletionMonth1: "",
    waterCompletionMonth2: "",
    waterCompletionMonth3: "",
    waterCompletionMonth4: "",
    waterCompletionMonth5: "",
    waterCompletionMonth6: "",
    waterCompletionMonth7: "",
    waterCompletionMonth8: "",
    waterCompletionMonth9: "",
    waterCompletionMonth10: "",
    waterCompletionMonth11: "",
    waterCompletionMonth12: "",
    //---月节能完成率
    waterSavingRateMonth1: "",
    waterSavingRateMonth2: "",
    waterSavingRateMonth3: "",
    waterSavingRateMonth4: "",
    waterSavingRateMonth5: "",
    waterSavingRateMonth6: "",
    waterSavingRateMonth7: "",
    waterSavingRateMonth8: "",
    waterSavingRateMonth9: "",
    waterSavingRateMonth10: "",
    waterSavingRateMonth11: "",
    waterSavingRateMonth12: "",

    //--月下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //-------------------------气------------------------
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气节能完成度评价
    gasCompletionMonth1: "",
    gasCompletionMonth2: "",
    gasCompletionMonth3: "",
    gasCompletionMonth4: "",
    gasCompletionMonth5: "",
    gasCompletionMonth6: "",
    gasCompletionMonth7: "",
    gasCompletionMonth8: "",
    gasCompletionMonth9: "",
    gasCompletionMonth10: "",
    gasCompletionMonth11: "",
    gasCompletionMonth12: "",
    //---月节能完成率
    gasSavingRateMonth1: "",
    gasSavingRateMonth2: "",
    gasSavingRateMonth3: "",
    gasSavingRateMonth4: "",
    gasSavingRateMonth5: "",
    gasSavingRateMonth6: "",
    gasSavingRateMonth7: "",
    gasSavingRateMonth8: "",
    gasSavingRateMonth9: "",
    gasSavingRateMonth10: "",
    gasSavingRateMonth11: "",
    gasSavingRateMonth12: "",

    //--月下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //--------------------热-------------------------------
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热节能完成度评价
    hotCompletionMonth1: "",
    hotCompletionMonth2: "",
    hotCompletionMonth3: "",
    hotCompletionMonth4: "",
    hotCompletionMonth5: "",
    hotCompletionMonth6: "",
    hotCompletionMonth7: "",
    hotCompletionMonth8: "",
    hotCompletionMonth9: "",
    hotCompletionMonth10: "",
    hotCompletionMonth11: "",
    hotCompletionMonth12: "",
    //---月节能完成率
    hotSavingRateMonth1: "",
    hotSavingRateMonth2: "",
    hotSavingRateMonth3: "",
    hotSavingRateMonth4: "",
    hotSavingRateMonth5: "",
    hotSavingRateMonth6: "",
    hotSavingRateMonth7: "",
    hotSavingRateMonth8: "",
    hotSavingRateMonth9: "",
    hotSavingRateMonth10: "",
    hotSavingRateMonth11: "",
    hotSavingRateMonth12: "",


    //--月下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
    //--------------------------------------其他----

    othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他节能完成度评价
    othersCompletionMonth1: "",
    othersCompletionMonth2: "",
    othersCompletionMonth3: "",
    othersCompletionMonth4: "",
    othersCompletionMonth5: "",
    othersCompletionMonth6: "",
    othersCompletionMonth7: "",
    othersCompletionMonth8: "",
    othersCompletionMonth9: "",
    othersCompletionMonth10: "",
    othersCompletionMonth11: "",
    othersCompletionMonth12: "",
    //---其他节能完成率
    othersSavingRateMonth1: "",
    othersSavingRateMonth2: "",
    othersSavingRateMonth3: "",
    othersSavingRateMonth4: "",
    othersSavingRateMonth5: "",
    othersSavingRateMonth6: "",
    othersSavingRateMonth7: "",
    othersSavingRateMonth8: "",
    othersSavingRateMonth9: "",
    othersSavingRateMonth10: "",
    othersSavingRateMonth11: "",
    othersSavingRateMonth12: "",


    //--其他下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
      }
    };
  },
  created() {
   
    getPerformancLevel1(this.queryParams).then((response) => {
          // alert("11111");
          this.performancLevel1VO = response.data;
 
 
        //------------------
               //年报
    // this.monthlyProportionOptions = this.monthlyProportion();
    // this.monthlyProportionOptionsRate = this.monthlyProportionRate(0);
    // this.monthlyProportionOptionsRate3 = this.monthlyProportionRate3();
    //    //季报
   
    // this.seasonProportionOptions = this.seasonProportion();
     this.seasonProportionOptionsRate = this.seasonProportionRate(0);
     this.typeflag=0;
    //  this.seasonProportionOptionsRate3 = this.seasonProportionRate3(); 
       //月报
   // this.yearlyProportionOptions = this.yearlyProportion(); 
    //this.yearlyProportionOptionsRate = this.yearlyProportionRate();
    //this.yearlyProportionOptionsRate3 = this.yearlyProportionRate3();
        //--------------
        
         });
    
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
        /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listLevel1(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
            if(response.rows[i].energyType==1){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
               response.rows[i].energyType='电';
            }
            if(response.rows[i].energyType==2){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='水';}
              if(response.rows[i].energyType==3){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='气';}
            
            if(response.rows[i].energyType==4){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='热';
            }
              if(response.rows[i].energyType==5){
                response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='其他能源'; 
              }
        }
      
        this.consumptionlist = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
        setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
       getChange(typeid){
          // alert(typeid);
              if(typeid==0){
        
          //总月度数据 
           this.typeflag=0;
          this.seasonProportionOptionsRate = this.seasonProportionRate(0);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(0);
          
        }
        if(typeid==1){
        
          //电月度数据 
           this.typeflag=1;
          this.seasonProportionOptionsRate = this.seasonProportionRate(1);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(1);
          
        }else if(typeid==2){
          //水月度数据 
            this.typeflag=2;
          this.seasonProportionOptionsRate = this.seasonProportionRate(2);
          // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(2);
        }else if(typeid==3){
         //气月度数据 
           this.typeflag=3;
         this.seasonProportionOptionsRate = this.seasonProportionRate(3);
          //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(3);
        }else if(typeid==4){
          //热月度数据 
            this.typeflag=4;
          this.seasonProportionOptionsRate = this.seasonProportionRate(4);
           //this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(4);
        }else if(typeid==5){
         // 其他月度数据 
           this.typeflag=5;
         this.seasonProportionOptionsRate = this.seasonProportionRate(5);
         // this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }
      },
     
     seasonProportionRate(flag) {
 if(flag==null || flag=="undefined")
             flag=0;
      
           var value="";
           var change="";
           var changerate="";
          
           var date = new Date();
         var curmonth=date.getMonth(); 
           var curseason = 1;
           if(curmonth<3)
              curseason=1;
           else if(curmonth<6)
              curseason=2;
           else if(curmonth<9)
              curseason=3;
           else if(curmonth<12)  
               curseason=4; 
            this.curseasonflag=curseason;   
            if(flag==0){
             switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                  this.rightHeader=[
                     {
                          label: '1季度',
                          key: '1季度'
                          },
                          // {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.totalForecastSeason1,
                      //  "2季度": this.performancLevel1VO.totalForecastSeason2,
                      //   "3季度": this.performancLevel1VO.totalForecastSeason3,
                      //   "4季度": this.performancLevel1VO.totalForecastSeason4,
                       
                     }
                  ];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.totalForecastSeason1},
                    //   {time:'2季度',forecast:this.quotaLevel1VO.totalForecastSeason2},
                    //  {time:'3季度',forecast:this.quotaLevel1VO.totalForecastSeason3},
                    //  {time:'4季度',forecast:this.quotaLevel1VO.totalForecastSeason4},
                   
                  ];
                 
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.totalCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.totalSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.totalSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                   this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.totalForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.totalForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.totalForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.totalForecastSeason4},
                   
                  ];
                   this.rightHeader=[
                     {
                          label: '1季度',
                          key: '1季度'
                          },
                          {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.totalForecastSeason1,
                       "2季度": this.performancLevel1VO.totalForecastSeason2,
                        // "3季度": this.performancLevel1VO.totalForecastSeason3,
                        // "4季度": this.performancLevel1VO.totalForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.totalCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.totalCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.totalSeason1,
                  this.performancLevel1VO.totalSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.totalSavingRateSeason1,
                  this.performancLevel1VO.totalSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.totalForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.totalForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.totalForecastSeason3},
                     // {time:'4季度',forecast:this.performancLevel1VO.totalForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                     {
                          label: '1季度',
                          key: '1季度'
                          },
                          {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.totalForecastSeason1,
                       "2季度": this.performancLevel1VO.totalForecastSeason2,
                        "3季度": this.performancLevel1VO.totalForecastSeason3,
                      //  "4季度": this.performancLevel1VO.totalForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.totalCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.totalCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.totalCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.totalSeason1,
                  this.performancLevel1VO.totalSeason2,
                  this.performancLevel1VO.totalSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.totalSavingRateSeason1,
                  this.performancLevel1VO.totalSavingRateSeason2,
                  this.performancLevel1VO.totalSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.totalForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.totalForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.totalForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.totalForecastSeason4},
                   
                  ];
                 this.rightHeader=[
                     {
                          label: '1季度',
                          key: '1季度'
                          },
                          {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.totalForecastSeason1,
                       "2季度": this.performancLevel1VO.totalForecastSeason2,
                        "3季度": this.performancLevel1VO.totalForecastSeason3,
                        "4季度": this.performancLevel1VO.totalForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.totalCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.totalCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.totalCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.totalCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.totalSeason1,
                        this.performancLevel1VO.totalSeason2,
                        this.performancLevel1VO.totalSeason3,
                        this.performancLevel1VO.totalSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.totalSavingRateSeason1,
                  this.performancLevel1VO.totalSavingRateSeason2,
                  this.performancLevel1VO.totalSavingRateSeason3,
                  this.performancLevel1VO.totalSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
            if(flag==1){
              switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                     this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.powerForecastSeason1},
                      //  {time:'2季度',forecast:this.performancLevel1VO.powerForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.powerForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.powerForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                          //  {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.powerForecastSeason1,
                        // "2季度": this.performancLevel1VO.powerForecastSeason2,
                        // "3季度": this.performancLevel1VO.powerForecastSeason3,
                        // "4季度": this.performancLevel1VO.powerForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.powerCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.powerSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.powerSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.powerForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.powerForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.powerForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.powerForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.powerForecastSeason1,
                        "2季度": this.performancLevel1VO.powerForecastSeason2,
                        // "3季度": this.performancLevel1VO.powerForecastSeason3,
                        // "4季度": this.performancLevel1VO.powerForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.powerCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.powerCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.powerSeason1,
                  this.performancLevel1VO.powerSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.powerSavingRateSeason1,
                  this.performancLevel1VO.powerSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.powerForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.powerForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.powerForecastSeason3},
                     // {time:'4季度',forecast:this.performancLevel1VO.powerForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.powerForecastSeason1,
                        "2季度": this.performancLevel1VO.powerForecastSeason2,
                        "3季度": this.performancLevel1VO.powerForecastSeason3,
                    //    "4季度": this.performancLevel1VO.powerForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.powerCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.powerCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.powerCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.powerSeason1,
                  this.performancLevel1VO.powerSeason2,
                  this.performancLevel1VO.powerSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.powerSavingRateSeason1,
                  this.performancLevel1VO.powerSavingRateSeason2,
                  this.performancLevel1VO.powerSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.powerForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.powerForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.powerForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.powerForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.powerForecastSeason1,
                        "2季度": this.performancLevel1VO.powerForecastSeason2,
                        "3季度": this.performancLevel1VO.powerForecastSeason3,
                        "4季度": this.performancLevel1VO.powerForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.powerCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.powerCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.powerCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.powerCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.powerSeason1,
                        this.performancLevel1VO.powerSeason2,
                        this.performancLevel1VO.powerSeason3,
                        this.performancLevel1VO.powerSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.powerSavingRateSeason1,
                  this.performancLevel1VO.powerSavingRateSeason2,
                  this.performancLevel1VO.powerSavingRateSeason3,
                  this.performancLevel1VO.powerSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
           if(flag==2){
              switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.waterForecastSeason1},
                      //  {time:'2季度',forecast:this.performancLevel1VO.waterForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.waterForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.waterForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                          //   {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.waterForecastSeason1,
                        // "2季度": this.performancLevel1VO.waterForecastSeason2,
                        // "3季度": this.performancLevel1VO.waterForecastSeason3,
                        // "4季度": this.performancLevel1VO.waterForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.waterCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.waterSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.waterSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.waterForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.waterForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.waterForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.waterForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.waterForecastSeason1,
                        "2季度": this.performancLevel1VO.waterForecastSeason2,
                        // "3季度": this.performancLevel1VO.waterForecastSeason3,
                        // "4季度": this.performancLevel1VO.waterForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.waterCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.waterCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.waterSeason1,
                  this.performancLevel1VO.waterSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.waterSavingRateSeason1,
                  this.performancLevel1VO.waterSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.waterForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.waterForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.waterForecastSeason3},
                     // {time:'4季度',forecast:this.performancLevel1VO.waterForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.waterForecastSeason1,
                        "2季度": this.performancLevel1VO.waterForecastSeason2,
                        "3季度": this.performancLevel1VO.waterForecastSeason3,
                      //  "4季度": this.performancLevel1VO.waterForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.waterCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.waterCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.waterCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.waterSeason1,
                  this.performancLevel1VO.waterSeason2,
                  this.performancLevel1VO.waterSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.waterSavingRateSeason1,
                  this.performancLevel1VO.waterSavingRateSeason2,
                  this.performancLevel1VO.waterSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.waterForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.waterForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.waterForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.waterForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.waterForecastSeason1,
                        "2季度": this.performancLevel1VO.waterForecastSeason2,
                        "3季度": this.performancLevel1VO.waterForecastSeason3,
                        "4季度": this.performancLevel1VO.waterForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.waterCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.waterCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.waterCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.waterCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.waterSeason1,
                        this.performancLevel1VO.waterSeason2,
                        this.performancLevel1VO.waterSeason3,
                        this.performancLevel1VO.waterSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.waterSavingRateSeason1,
                  this.performancLevel1VO.waterSavingRateSeason2,
                  this.performancLevel1VO.waterSavingRateSeason3,
                  this.performancLevel1VO.waterSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
            if(flag==3){
              switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.gasForecastSeason1},
                      //  {time:'2季度',forecast:this.performancLevel1VO.gasForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.gasForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.gasForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                          //  {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.gasForecastSeason1,
                        // "2季度": this.performancLevel1VO.gasForecastSeason2,
                        // "3季度": this.performancLevel1VO.gasForecastSeason3,
                        // "4季度": this.performancLevel1VO.gasForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.gasCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.gasSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.gasSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.gasForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.gasForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.gasForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.gasForecastSeason4},
                   
                  ];
                 this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.gasForecastSeason1,
                        "2季度": this.performancLevel1VO.gasForecastSeason2,
                        // "3季度": this.performancLevel1VO.gasForecastSeason3,
                        // "4季度": this.performancLevel1VO.gasForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.gasCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.gasCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.gasSeason1,
                  this.performancLevel1VO.gasSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.gasSavingRateSeason1,
                  this.performancLevel1VO.gasSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.gasForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.gasForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.gasForecastSeason3},
                   //   {time:'4季度',forecast:this.performancLevel1VO.gasForecastSeason4},
                   
                  ];
                 this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.gasForecastSeason1,
                        "2季度": this.performancLevel1VO.gasForecastSeason2,
                        "3季度": this.performancLevel1VO.gasForecastSeason3,
                   //     "4季度": this.performancLevel1VO.gasForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.gasCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.gasCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.gasCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.gasSeason1,
                  this.performancLevel1VO.gasSeason2,
                  this.performancLevel1VO.gasSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.gasSavingRateSeason1,
                  this.performancLevel1VO.gasSavingRateSeason2,
                  this.performancLevel1VO.gasSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.gasForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.gasForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.gasForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.gasForecastSeason4},
                   
                  ];
                 this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.gasForecastSeason1,
                        "2季度": this.performancLevel1VO.gasForecastSeason2,
                        "3季度": this.performancLevel1VO.gasForecastSeason3,
                        "4季度": this.performancLevel1VO.gasForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.gasCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.gasCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.gasCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.gasCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.gasSeason1,
                        this.performancLevel1VO.gasSeason2,
                        this.performancLevel1VO.gasSeason3,
                        this.performancLevel1VO.gasSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.gasSavingRateSeason1,
                  this.performancLevel1VO.gasSavingRateSeason2,
                  this.performancLevel1VO.gasSavingRateSeason3,
                  this.performancLevel1VO.gasSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
            if(flag==4){
              switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.hotForecastSeason1},
                      //  {time:'2季度',forecast:this.performancLevel1VO.hotForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.hotForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.hotForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                          //   {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.hotForecastSeason1,
                        // "2季度": this.performancLevel1VO.hotForecastSeason2,
                        // "3季度": this.performancLevel1VO.hotForecastSeason3,
                        // "4季度": this.performancLevel1VO.hotForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.hotCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.hotSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.hotSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.hotForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.hotForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.hotForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.hotForecastSeason4},
                   
                  ];
                   this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.hotForecastSeason1,
                        "2季度": this.performancLevel1VO.hotForecastSeason2,
                       // "3季度": this.performancLevel1VO.hotForecastSeason3,
                        // "4季度": this.performancLevel1VO.hotForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.hotCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.hotCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.hotSeason1,
                  this.performancLevel1VO.hotSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.hotSavingRateSeason1,
                  this.performancLevel1VO.hotSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.hotForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.hotForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.hotForecastSeason3},
                    //  {time:'4季度',forecast:this.performancLevel1VO.hotForecastSeason4},
                   
                  ];
                   this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.hotForecastSeason1,
                        "2季度": this.performancLevel1VO.hotForecastSeason2,
                        "3季度": this.performancLevel1VO.hotForecastSeason3,
                     //   "4季度": this.performancLevel1VO.hotForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.hotCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.hotCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.hotCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.hotSeason1,
                  this.performancLevel1VO.hotSeason2,
                  this.performancLevel1VO.hotSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.hotSavingRateSeason1,
                  this.performancLevel1VO.hotSavingRateSeason2,
                  this.performancLevel1VO.hotSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.hotForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.hotForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.hotForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.hotForecastSeason4},
                   
                  ];
                 this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                            {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.hotForecastSeason1,
                        "2季度": this.performancLevel1VO.hotForecastSeason2,
                        "3季度": this.performancLevel1VO.hotForecastSeason3,
                        "4季度": this.performancLevel1VO.hotForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.hotCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.hotCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.hotCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.hotCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.hotSeason1,
                        this.performancLevel1VO.hotSeason2,
                        this.performancLevel1VO.hotSeason3,
                        this.performancLevel1VO.hotSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.hotSavingRateSeason1,
                  this.performancLevel1VO.hotSavingRateSeason2,
                  this.performancLevel1VO.hotSavingRateSeason3,
                  this.performancLevel1VO.hotSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
           if(flag==5){
              switch(curseason){
                case 1:
                  this.montharr=["1季度"];
                  this.montharr2=["2季度","3季度","4季度"];
                  this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.othersForecastSeason1},
                      //  {time:'2季度',forecast:this.performancLevel1VO.othersForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.othersForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.othersForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                          //  {
                          // label: '2季度',
                          // key: '2季度'
                          // },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.othersForecastSeason1,
                        // "2季度": this.performancLevel1VO.othersForecastSeason2,
                        // "3季度": this.performancLevel1VO.othersForecastSeason3,
                        // "4季度": this.performancLevel1VO.othersForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[{
                    date: '1季度',
                    name: this.performancLevel1VO.othersCompletionSeason1,
                 
                    }, 
                  
                  ];
                  this.dataarr=[this.performancLevel1VO.othersSeason1];//目标值
                  this.dataarr2=[this.performancLevel1VO.othersSavingRateSeason1];//实际值
                  
                    break;
                  
                case 2: 
                   this.montharr=["1季度","2季度"];
                  this.montharr2=["3季度","4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.othersForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.othersForecastSeason2},
                      // {time:'3季度',forecast:this.performancLevel1VO.othersForecastSeason3},
                      // {time:'4季度',forecast:this.performancLevel1VO.othersForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          // {
                          // label: '3季度',
                          // key: '3季度'
                          // },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.othersForecastSeason1,
                        "2季度": this.performancLevel1VO.othersForecastSeason2,
                        // "3季度": this.performancLevel1VO.othersForecastSeason3,
                        // "4季度": this.performancLevel1VO.othersForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.othersCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.othersCompletionSeason2,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.othersSeason1,
                  this.performancLevel1VO.othersSeason2];//目标值
                  this.dataarr2=[this.performancLevel1VO.othersSavingRateSeason1,
                  this.performancLevel1VO.othersSavingRateSeason2];//实际值
                   
                      break;
                case 3:
                  this.montharr=["1季度","2季度","3季度"];
                  this.montharr2=["4季度"];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.othersForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.othersForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.othersForecastSeason3},
                     // {time:'4季度',forecast:this.performancLevel1VO.othersForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          // {
                          // label: '4季度',
                          // key: '4季度'
                          // },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.othersForecastSeason1,
                        "2季度": this.performancLevel1VO.othersForecastSeason2,
                        "3季度": this.performancLevel1VO.othersForecastSeason3,
                       // "4季度": this.performancLevel1VO.othersForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.othersCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.othersCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.othersCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.othersSeason1,
                  this.performancLevel1VO.othersSeason2,
                  this.performancLevel1VO.othersSeason3];//目标值
                  this.dataarr2=[this.performancLevel1VO.othersSavingRateSeason1,
                  this.performancLevel1VO.othersSavingRateSeason2,
                  this.performancLevel1VO.othersSavingRateSeason3];//实际值
                            break;
                case 4:
                this.montharr=["1季度","2季度","3季度","4季度"];
                  this.montharr2=[];
                    this.performancForecast=[
                         {time:'1季度',forecast:this.performancLevel1VO.othersForecastSeason1},
                       {time:'2季度',forecast:this.performancLevel1VO.othersForecastSeason2},
                      {time:'3季度',forecast:this.performancLevel1VO.othersForecastSeason3},
                      {time:'4季度',forecast:this.performancLevel1VO.othersForecastSeason4},
                   
                  ];
                  this.rightHeader=[
                          {
                          label: '1季度',
                          key: '1季度'
                          },
                           {
                          label: '2季度',
                          key: '2季度'
                          },
                          {
                          label: '3季度',
                          key: '3季度'
                          },
                          {
                          label: '4季度',
                          key: '4季度'
                          },
                         
                         
                  ];
                  this.rightsDate=[
                     {
                       "1季度": this.performancLevel1VO.othersForecastSeason1,
                        "2季度": this.performancLevel1VO.othersForecastSeason2,
                        "3季度": this.performancLevel1VO.othersForecastSeason3,
                        "4季度": this.performancLevel1VO.othersForecastSeason4,
                       
                     }
                  ];
                  this.tableData=[
                    {
                    date: '1季度',
                    name: this.performancLevel1VO.othersCompletionSeason1,
                 
                    }, 
                  {
                    date: '2季度',
                    name: this.performancLevel1VO.othersCompletionSeason2,
                 
                    }, 
                     {
                    date: '3季度',
                    name: this.performancLevel1VO.othersCompletionSeason3,
                 
                    }, 
                     {
                    date: '4季度',
                    name: this.performancLevel1VO.othersCompletionSeason3,
                 
                    }, 
                  ];
                  this.dataarr=[this.performancLevel1VO.othersSeason1,
                        this.performancLevel1VO.othersSeason2,
                        this.performancLevel1VO.othersSeason3,
                        this.performancLevel1VO.othersSeason4];//目标值
                  this.dataarr2=[this.performancLevel1VO.othersSavingRateSeason1,
                  this.performancLevel1VO.othersSavingRateSeason2,
                  this.performancLevel1VO.othersSavingRateSeason3,
                  this.performancLevel1VO.othersSavingRateSeason4];//实际值
                             break;
               

             }
            // dataarr=
          };
           
           
      return {
        title: {
          text: "",
          textStyle: {
            fontSize: 16,
            color: "#000",
            fontWeight: "bolder",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "cross" },
        },
         color:['#00BFFF','#FFB90F'],
        legend: {
          x: "right",
          right: 50,
          data: ["目标节能", "实际节能"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.montharr,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "目标节能",
            type: "bar",
            data: this.dataarr,
            // data: [this.performancLevel1VO.totalSavingRateMonth1,
            //       this.performancLevel1VO.totalSavingRateMonth2,
            //       this.performancLevel1VO.totalSavingRateMonth3,
             
            // ],
          },
          {
            name: "实际节能",
            type: "bar",
            data: this.dataarr2,
            //  data: [this.performancLevel1VO.powerSavingRateMonth1,
            //       this.performancLevel1VO.powerSavingRateMonth2,
            //       this.performancLevel1VO.powerSavingRateMonth3,
          
            // ],
          },
         
        ],
      };
    },
   
     
   }
}
</script>
<style scoped src="../../../../../../assets/common/performanc/css/season/styles.css"></style>
<style scoped>
   @import "../../../../../../assets/common/consumption/css/styles.css";
   @import "../../../../../../assets/common/rp_page.css";
</style>
